import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import toastr from 'toastr';

export default {
  publicFolderLinkController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    '$filter',
    'folderService',
    '$uibModal',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $uibModalInstance,
      $filter,
      folderService,
      $uibModal,
    ) {
      'use strict';

      function getFolderShared() {
        $scope.isLoading = true;
        folderService
          .shared($rootScope.folderContextMenu.Id)
          .then((folderAutoLogin) => {
            $scope.isLoading = false;

            $scope.documentLink =
              window.location.origin +
              '/#/login/autologin/' +
              folderAutoLogin.AutologinToken;

            if (
              folderAutoLogin.PublicLinkDate &&
              typeof folderAutoLogin.PublicLinkDate === 'string'
            ) {
              const valueInput = folderAutoLogin.PublicLinkDate.substring(
                0,
                10
              );
              var ArrayNotBar = valueInput.split('/');
              const ValueInputFormat = `${ArrayNotBar[2]}-${ArrayNotBar[1]}-${ArrayNotBar[0]}`;
              $scope.nextRevisionDate = new Date(ValueInputFormat);
            }
          })
          .catch((error) => {
            swal.fire({
              title: error.title,
              text: error.text,
              icon: 'error',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
              preConfirm: () => {
                return new Promise((resolve) => {
                  $uibModalInstance.dismiss('cancel');
                  resolve();
                });
              },
            });
          });
      }

      function viewFolderLink() {
        const url = document.querySelector('#inputFolderLink').value;
        window.open(url, '_blank');
      }

      function EnableButton() {
        $scope.isEndDateDisabled = !$scope.isEndDateDisabled;
      }

      function isExpiredFolderLink() {
        const valueInput = document.querySelector('#endDate').value;

        if (valueInput === '') {
          return false;
        }

        const DateToday = new Date();
        $scope.Today = DateToday.toISOString().substring(0, 10);

        var ArrayNotBar = valueInput.split('/');

        const ValueInputFormat = `${ArrayNotBar[2]}-${ArrayNotBar[1]}-${ArrayNotBar[0]}`;

        $scope.publicDateRev = ValueInputFormat;
        $scope.PublicLinkDateExpire = new Date(ValueInputFormat);

        if ($scope.publicDateRev >= $scope.Today) {
          return false;
        } else {
          return true;
        }
      }

      function cancelLink() {
        $scope.loading = true;
        $scope.loadingText = $filter('translate')(
          'LOADING CANCELING PUBLIC LINK'
        );

        folderService
          .deleteShared($rootScope.folderContextMenu.Id)
          .then(() => {
            $scope.close();
            $scope.showNotification('info', 'PUBLIC LINK FOLDER CANCELED');
            $rootScope.loadDocs();
          })
          .catch((err) => {
            $scope.showNotification('error', err.error_description);
            $scope.loading = false;
          });
      }

      function notifyLinkCopy() {
        $scope.showNotification('info', 'PUBLIC LINK COPIED');
      }

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          debug: false,
          progressBar: false,
          preventDuplicates: false,
          positionClass: 'toast-top-center',
          showDuration: '1000',
          hideDuration: '1000',
          timeOut: '7000',
          extendedTimeOut: '1000',
          showEasing: 'swing',
          hideEasing: 'linear',
          showMethod: 'fadeIn',
          hideMethod: 'fadeOut',
        };

        toastr[level]($filter('translate')(msg));
      }

      function close() {
        $rootScope.sharedFolderModal.close();
      }

      function save() {
        if ($scope.PublicLinkDateExpire !== undefined) {
          folderService
            .shared(
              $rootScope.folderContextMenu.Id,
              $scope.PublicLinkDateExpire
            )
            .then(() => {
              openSuccessModal();
            })
            .catch((error) => {
              swal.fire({
                title: error.title,
                text: error.text,
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
                preConfirm: () => {
                  return new Promise((resolve) => {
                    $uibModalInstance.dismiss('cancel');
                    resolve();
                  });
                },
              });
            });
        } else {
          openSuccessModal();
        }
      }

      function openSuccessModal() {
        $rootScope.sharedFolderModal.close();

        $rootScope.publicFolderLinkSucessModal = $uibModal.open({
          animation: true,
          templateUrl: 'views/modal/successModal/successModal.html',
          controller: 'publicFolderLinkController',
          windowClass: 'modal-center-window',
          backdrop: 'static',
          keyboard: true,
          size: 'm'
        });
      }

      function closeSuccessModal() {
        $rootScope.publicFolderLinkSucessModal.close();

        $rootScope.loadDocs();
      }

      function run() {
        try {
          $scope.documentLink = '';
          $scope.loading = true;
          $scope.loadingText = $filter('translate')(
            'LOADING FOLDER PUBLIC LINK'
          );
          $scope.messageDescription = $filter('translate')('PUBLIC LINK SAVE');
          $scope.messageCancel = 'OK';
          $scope.messageTitle = $filter('translate')('PUBLIC LINK');

          $scope.isEndDateDisabled = false;

          $scope.getFolderShared = logWrapper(
            getFolderShared,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.viewFolderLink = logWrapper(
            viewFolderLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.EnableButton = logWrapper(
            EnableButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isExpiredFolderLink = logWrapper(
            isExpiredFolderLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelLink = logWrapper(
            cancelLink,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.notifyLinkCopy = logWrapper(
            notifyLinkCopy,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.showNotification = logWrapper(
            showNotification,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openSuccessModal = logWrapper(
            openSuccessModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeSuccessModal = logWrapper(
            closeSuccessModal,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
